import enMessages from "./en.json";
import esMessages from "./es.json";

// Definir la estructura de las traducciones
type Messages = typeof enMessages;

// Exportar los tipos
export type Locale = "en" | "es";
export type TranslationKeys = keyof Messages;

// Exportar las traducciones
export const messages: Record<Locale, Messages> = {
  en: enMessages,
  es: esMessages,
};
